import LegalDocument, { LegalSection, OwnershipNotice } from "../components/LegalDocument";

export default function Terms() {
  return (
    <LegalDocument
      titleEn="Terms of Use"
      titleAr="شروط الاستخدام"
      descriptionEn="These terms describe the appropriate use of Dialysis Diet Pro."
      descriptionAr="توضح هذه الشروط الاستخدام المناسب لتطبيق Dialysis Diet Pro."
    >
      <LegalSection titleEn="1. Purpose and Acceptance" titleAr="1. الغرض والموافقة">
        {{
          childrenEn: (
            <p>
              By using Dialysis Diet Pro, you agree to use it as an educational and
              nutrition tracking tool and to follow these Terms of Use.
            </p>
          ),
          childrenAr: (
            <p>
              باستخدامك تطبيق Dialysis Diet Pro، فإنك توافق على استخدامه كأداة تعليمية
              ولتتبع التغذية وعلى الالتزام بشروط الاستخدام هذه.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="2. Use of the App" titleAr="2. استخدام التطبيق">
        {{
          childrenEn: (
            <>
              <p>
                The app helps record foods, nutrient information, history, reports, and
                reminders for tracking purposes.
              </p>
              <p>
                You are responsible for providing accurate information and keeping any
                account access secure.
              </p>
            </>
          ),
          childrenAr: (
            <>
              <p>
                يساعد التطبيق على تسجيل الأطعمة ومعلومات العناصر الغذائية والسجل
                والتقارير والتذكيرات لأغراض التتبع.
              </p>
              <p>
                تقع على عاتقك مسؤولية تقديم معلومات دقيقة والحفاظ على أمان الوصول إلى
                حسابك إن وجد.
              </p>
            </>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="3. Guest and Registered Access" titleAr="3. استخدام الضيف والحساب المسجل">
        {{
          childrenEn: (
            <p>
              Registered accounts store app data associated with that account. Guest Mode
              keeps guest entries on the browser or device used for the session. Do not
              share passwords or account access.
            </p>
          ),
          childrenAr: (
            <p>
              تخزن الحسابات المسجلة بيانات التطبيق المرتبطة بالحساب. أما وضع الضيف
              فيحتفظ بمدخلات الضيف على المتصفح أو الجهاز المستخدم للجلسة. لا تشارك كلمة
              المرور أو الوصول إلى الحساب مع أي شخص.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="4. Medical Limitation" titleAr="4. الحدود الطبية">
        {{
          childrenEn: (
            <p>
              Dialysis Diet Pro is for educational and tracking purposes only. It does not
              provide medical advice, diagnosis, or treatment and does not replace
              consultation with a doctor, nephrologist, or renal dietitian.
            </p>
          ),
          childrenAr: (
            <p>
              تطبيق Dialysis Diet Pro مخصص للأغراض التعليمية وللتتبع فقط. وهو لا يقدم
              نصيحة طبية أو تشخيصا أو علاجا، ولا يحل محل استشارة طبيب أو اختصاصي أمراض
              الكلى أو اختصاصي تغذية كلوية.
            </p>
          ),
        }}
      </LegalSection>

      <OwnershipNotice />
    </LegalDocument>
  );
}
